import { OverlayTrigger } from '@hai/ui-react';
import React, { FunctionComponent, HTMLAttributes, ReactNode } from 'react';

interface AWStreamingBadgeProps extends HTMLAttributes<HTMLDivElement> {
  status: 'streaming' | 'warning' | 'error';
  children: ReactNode;
  popoverContent?: string;
  popoverPlacement?: "top" | "right" | "top-center" | "bottom";
}

const AWStreamingBadge: FunctionComponent<AWStreamingBadgeProps> = ({
  children,
  status,
  popoverContent,
  popoverPlacement = "top",
  className,
  ...otherProps
}) => {
  return (
    <OverlayTrigger
      placement={popoverPlacement}
      popoverContent={popoverContent}
      popoverBgColor={status === 'error' ? 'haiui-red-01' : status === 'warning' ? 'haiui-amber-01' : undefined}
      popoverClass="streaming-badge-popover-content"
      {...otherProps}
      className={`streaming-badge ${status}${className ? ` ${className}` : ''}`}
    >
      {children}
    </OverlayTrigger>
  );
};

export default AWStreamingBadge;
